export class FailureAlertSetting{
  companyId?: string;
  mailAddresses?: string[];

  constructor(params?: Partial<FailureAlertSetting>) {
    Object.assign(this, params);
  }
}